import { OnEntryBeforeCreate } from "./entryHooks/index.js";

export { OnEntryBeforeCreate };

export const definitions = [OnEntryBeforeCreate.def];
